module.exports = __webpack_public_path__ + "static/media/amazonLogoDark.14c3b6d1.png";